import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/company_logo/logo.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed w-full top-0 z-50 bg-blue-900/95 backdrop-blur-sm shadow-lg border-b border-blue-800/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo & Brand */}
          <div className="flex items-center">
            <Link
              to="/"
              className="flex items-center space-x-3 text-white hover:text-accent transition-colors"
            >
              <img
                src={logo}
                alt="M Design Studio Logo"
                className="h-10 w-10 rounded-full object-cover scale-125"
              />

              <div className="flex flex-col leading-tight">
                <span className="text-lg font-serif font-bold">
                  M DESIGN STUDIO
                </span>
                <span className="text-[8px] font-serif tracking-wider text-yellow-200">
                  Vision Made Visible
                </span>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/"
              className={`transition-colors font-medium ${
                isActive("/")
                  ? "text-accent"
                  : "text-blue-100 hover:text-accent"
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`transition-colors font-medium ${
                isActive("/services")
                  ? "text-accent"
                  : "text-blue-100 hover:text-accent"
              }`}
            >
              Services
            </Link>
            <Link
              to="/gallery"
              className={`transition-colors font-medium ${
                isActive("/gallery")
                  ? "text-accent"
                  : "text-blue-100 hover:text-accent"
              }`}
            >
              Gallery
            </Link>
            <Link
              to="/clients"
              className={`transition-colors font-medium ${
                isActive("/clients")
                  ? "text-accent"
                  : "text-blue-100 hover:text-accent"
              }`}
            >
              Clients
            </Link>
            <Link
              to="/contact"
              className={`transition-colors font-medium ${
                isActive("/contact")
                  ? "text-accent"
                  : "text-blue-100 hover:text-accent"
              }`}
            >
              Contact
            </Link>
            <Link
              to="/careers"
              className={`transition-colors font-medium ${
                isActive("/careers")
                  ? "text-accent"
                  : "text-blue-100 hover:text-accent"
              }`}
            >
              Careers
            </Link>
            <Link
              to="/about"
              className={`transition-colors font-medium ${
                isActive("/about")
                  ? "text-accent"
                  : "text-blue-100 hover:text-accent"
              }`}
            >
              About
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <div className="w-6 h-6 flex flex-col justify-center items-center">
              <span
                className={`bg-blue-100 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${
                  isMenuOpen ? "rotate-45 translate-y-1" : "-translate-y-0.5"
                }`}
              ></span>
              <span
                className={`bg-blue-100 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm my-0.5 ${
                  isMenuOpen ? "opacity-0" : "opacity-100"
                }`}
              ></span>
              <span
                className={`bg-blue-100 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${
                  isMenuOpen ? "-rotate-45 -translate-y-1" : "translate-y-0.5"
                }`}
              ></span>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-blue-900 border-t border-blue-800">
              {["/", "/services", "/gallery", "/clients", "/contact", "/careers", "/about"].map(
                (path, index) => (
                  <Link
                    key={index}
                    to={path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`block px-3 py-2 font-medium ${
                      isActive(path)
                        ? "text-accent"
                        : "text-blue-100 hover:text-accent"
                    }`}
                  >
                    {path === "/"
                      ? "Home"
                      : path.replace("/", "").charAt(0).toUpperCase() +
                        path.replace("/", "").slice(1)}
                  </Link>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
